import { GetWorkflowSettingsResult } from "generated/graphql";
import React from "react";
import { EmailActionEditor } from "./email-action-editor";
import {
    hasSingleEmailAction,
    hasSingleSmsAction,
    hasSingleTaskAction,
} from "./manage-workflows-helper";
import { TaskActionEditor } from "./task-action-editor";
import { EditableWorkflow } from "./types";
import { WorkflowActionSummary } from "./workflow-action-summary";

interface WorkflowActionEditorProps {
    workflow: EditableWorkflow;
    workflowSettings: GetWorkflowSettingsResult;
    onChange: (workflow: EditableWorkflow) => void;
}

export const WorkflowActionEditor: React.FC<WorkflowActionEditorProps> = props => {
    const { workflow, workflowSettings, onChange } = props;
    const firstActionId = workflow.actions[0]?.id ?? null;

    if (workflow.actions.length > 1) {
        return (
            <div className="space-y-2">
                <p className="text-sm text-gray-600">
                    This workflow runs several actions in sequence.
                </p>
                <WorkflowActionSummary
                    workflow={workflow}
                    workflowSettings={workflowSettings}
                />
            </div>
        );
    }
    if (hasSingleTaskAction(workflow) && firstActionId) {
        return (
            <TaskActionEditor
                workflow={workflow}
                actionId={firstActionId}
                onChange={onChange}
            />
        );
    } else if (hasSingleEmailAction(workflow)) {
        return <EmailActionEditor workflow={workflow} onChange={onChange} />;
    } else if (hasSingleSmsAction(workflow)) {
        return (
            <div className="text-sm text-gray-600">
                SMS action &mdash; edit this action in the workflow builder.
            </div>
        );
    }

    return null;
};
